module.exports = __webpack_public_path__ + "img/ring_y_o_null_1@3x.ca0a39b9.png";